import React from "react"
import Article from '../Article'

function BlankScreen(props) {

  const content = `<p>Quando estiver com a tela branca, recomendamos tentar abrir a aplica&ccedil;&atilde;o em um aba an&ocirc;nima do navegador e testar o link de acesso a smarstore com o seu pdv.
  &nbsp;</p>
  
  <p>ex: <span style="color:#3498db">https://totem.dex.co/?pdv=XX</span></p>
  
  <p><img alt="" src="/images/tela-branca-1.png" style="max-width: 90%" /></p>
  
  <p>Caso funcione na aba anônima, isso que dizer que tem um problema de cache com o navegador, para resolver é simples.</p>
  <p>Clique em configurações na barra de ferramenta do chrome.</p>
  
  <p><img alt="" src="/images/tela-branca-2.png" style="max-width: 90%" /></p>

  <p>Então selecione a opção de “Limpar dados de navegação”.</p>

  <p><img alt="" src="/images/tela-branca-3.png" style="max-width: 90%" /></p>

  <p>Dentro de Limpar dados de navegação, selecionar as opções “Avançado”, depois “Todo o período”, depois selecionar as caixas laterais de “Cookies e outros dados do site”, “Imagens e arquivos armazenados em cache” e “Dados do aplicativo hospedado”  (podem selecionar outras, mas esses são os principais). Após, deve-se selecionar Limpar os dados.</p>
  <p>Feito isso é necessário fechar e abrir o navegador novamente.</p>
  <p>Caso o erro continue dai escalar e de preferencia enviar alguma evidência (foto, mensagem de erro, etc...) que será investigado.</p>

  <p><img alt="" src="/images/tela-branca-4.png" style="max-width: 90%" /></p>
  
  `


  return (
    <Article article={content} title='Tela branca'/>
    )
  
}

export default BlankScreen
